import {useWindowSize} from '@wandb/weave/common/hooks/useWindowSize';
import React, {memo, useEffect} from 'react';
import {Route, Switch} from 'react-router';

import {
  useNavContext,
  useNavUpdaterContext,
} from '../../components/NavContextProvider';
import {InlineSidebar} from '../../components/PageWithSidebar/InlineSidebar';
import * as S from '../../components/PageWithSidebar/PageWithSidebar.styles';
import {useViewer} from '../../state/viewer/hooks';
import {setDocumentTitle} from '../../util/document';
import {HomePageSidebar} from './HomePageSidebar';
import {HOME_SIDEBAR_ROUTES} from './HomePageSidebar/homeSidebarRoutes';

export const HomePageWrapper = () => {
  useEffect(() => {
    setDocumentTitle('Home');
  }, []);

  // This component is the wrapper for all pages that display an inline
  // global nav sidebar, so updating the `isInline` state happens here.
  const {responsiveSize} = useWindowSize();
  const {updateGlobalNav} = useNavUpdaterContext();
  useEffect(() => {
    const isLargeScreen = responsiveSize === 'large';
    updateGlobalNav({isInline: isLargeScreen});
    return () => updateGlobalNav({isInline: false});
  }, [updateGlobalNav, responsiveSize]);

  return <HomePageWithData />;
};

const HomePageWithData = memo(() => {
  const viewer = useViewer();
  const isLoggedIn = !!viewer;
  const {globalNav} = useNavContext();
  return (
    <S.PageWithSidebar>
      {isLoggedIn && globalNav.isInline && (
        <InlineSidebar
          isOpen={globalNav.isOpen}
          shadow={globalNav.isTriggerHovered}
          shouldAnimate={globalNav.shouldAnimate}>
          <HomePageSidebar />
        </InlineSidebar>
      )}
      <Switch>
        {HOME_SIDEBAR_ROUTES.map((route, index) => {
          return <Route key={index} {...route} />;
        })}
      </Switch>
    </S.PageWithSidebar>
  );
});
HomePageWithData.displayName = 'HomePageWithData';

export default HomePageWrapper;
